import React from "react";
import AppStoreIcon from './Icon';

const AppStoreButton = () => (
  <a href="https://apps.apple.com/us/app/mitt-körkort/id1334597383" target="_blank" rel="noreferrer">
    <AppStoreIcon />
  </a>
)

export default AppStoreButton;